import { config } from '@config/config';
import { FC, Suspense, useState } from 'react';

interface Props {
  name: string;
}

const EmojiIcon: FC<Props> = ({ name }) => {
  const [imageError, setImageError] = useState(false);
  const cloudStorageUrl = config.gcp.cloudStorage.formLeadIconUrl;
  const extension = name === 'ellipsis' ? 'svg' : 'png'; // MEB convertir ellipsis un png
  const emojiUrl = `${cloudStorageUrl}${name}.${extension}`;
  const defaultImageUrl = `${cloudStorageUrl}rocket.png`;

  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <Suspense fallback={<div></div>}>
      <img
        height={32}
        src={imageError ? defaultImageUrl : emojiUrl}
        alt={name}
        onError={handleImageError}
      />
    </Suspense>
  );
};

export default EmojiIcon;
